import React, {Component} from 'react'
//import {TweenMax} from "gsap";

class HeaderMenu extends Component {

    constructor(props) {
        super(props)
        this.state = {
            links: [],
            pannels: [],
            currentPannel: null,
            searchMenuOpen: false,
            openNav: false,
            support: null,
            previousSupport: null,
            handlerEventFunctionOver: null,
            handlerEventFunctionClick: null,
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll.bind(this), false)
    }

    componentDidMount() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize.bind(this), false);

        this.props.proxy.querySelector('.hover-div-container').addEventListener('click', () => this.pannelOut());
        this.props.proxy.querySelector('.search-bar-container .overlay').addEventListener('click', (e) => this.closeSearchMenu(e));

        let hamburger = this.props.proxy.querySelector(".hamburger")
        hamburger.addEventListener("click", (e) => this.clickHamburger(e), false)

        let searchButton = this.props.proxy.querySelector('.search__cta')
        searchButton.addEventListener("click", (e) => this.toggleSearchMenu(e), false)

        let searchButtonMobile = this.props.proxy.querySelector('.magnifier-mobile.search__cta')
        searchButtonMobile.addEventListener("click", (e) => this.toggleSearchMenu(e), false)

        let searchForm = this.props.proxy.querySelector('.search-bar__form');
        searchForm.addEventListener('submit', (e) => this.submitSearch(e))

        this.handleScroll()
        window.addEventListener("scroll", this.handleScroll.bind(this), false)
    }

    setHeaderBackgroundHeight(height) {
        let maxHeight = this.props.maxheight
        let newHeight = maxHeight - height
        if (newHeight >= maxHeight) newHeight = maxHeight
        if (newHeight <= 0) newHeight = 0
        this.props.proxy.querySelector('.header-background').style.height = `${newHeight}px`
    }

    handleScroll() {
        let scrollTop = window.pageYOffset
        this.setHeaderBackgroundHeight(scrollTop)
        //let docHeight = document.body.clientHeight
        //var winHeight = window.innerHeight
        //let scrollPercent = (scrollTop) / (docHeight - winHeight)
        //let scrollPercentRounded = Math.round(scrollPercent * 100)
    }

    submitSearch(e) {
        if (e) {
            // e.preventDefault();
        }

        let searchInput = this.props.proxy.querySelector('.search-bar__input');
        console.log('search for ', searchInput.value)
    }

    closeSearchMenu(event) {
        if (this.state.searchMenuOpen) {
            this.closeSearchMenu();
        }
    }

    toggleSearchMenu(event) {
        if (this.state.searchMenuOpen) {
            this.closeSearchMenu();
        }
        else {
            this.openSearchMenu();
        }
    }

    openSearchMenu() {
        this.props.proxy.querySelector('.search-bar-container').classList.add("open");
        this.props.proxy.querySelector('.search-bar-container').className = this.props.proxy.querySelector('.search-bar-container').className.replace("close", "");

        //Replace desktop icon
        this.props.proxy.querySelector('.search__cta .right').className = this.props.proxy.querySelector('.search__cta .right').className.replace("icon-magnifier", "");
        this.props.proxy.querySelector('.search__cta .right').classList.add('icon-close')

        //Replace mobile icon
        this.props.proxy.querySelector('.magnifier-mobile.search__cta .right').className = this.props.proxy.querySelector('.magnifier-mobile.search__cta .right').className.replace("icon-magnifier", "");
        this.props.proxy.querySelector('.magnifier-mobile.search__cta .right').classList.add('icon-close')

        this.pannelOut()
        this.setState({
            searchMenuOpen: true
        })
        this.closeNav();
        this.hideCurrentPannel();

        //Input focus
        setTimeout(() => {
            this.props.proxy.querySelector('.search-bar .search-bar-content .content .search-bar__input').focus()
        }, 1000)
    }

    closeSearchMenu() {
        this.props.proxy.querySelector('.search-bar-container').className = this.props.proxy.querySelector('.search-bar-container').className.replace("open", "close");

        //Replace desktop icon
        this.props.proxy.querySelector('.search__cta .right').className = this.props.proxy.querySelector('.search__cta .right').className.replace("icon-close", "");
        this.props.proxy.querySelector('.search__cta .right').classList.add('icon-magnifier')

        //Replace mobile icon
        this.props.proxy.querySelector('.magnifier-mobile.search__cta .right').className = this.props.proxy.querySelector('.magnifier-mobile.search__cta .right').className.replace("icon-close", "");
        this.props.proxy.querySelector('.magnifier-mobile.search__cta .right').classList.add('icon-magnifier')
        this.setState({
            searchMenuOpen: false
        })
    }

    handleResize() {
        let windowWidth = window.innerWidth;

        if (windowWidth >= 1024) {
            this.setState({support: 'desktop'}, (state) => {
                if (this.state.support !== this.state.previousSupport) {
                    TweenMax.set(this.props.proxy.querySelector('.container-category'), {display: 'inline-block'})
                    this.removeEventClick();
                    this.initMouseOver()
                }
                this.setState({previousSupport: this.state.support})
            })

        }
        else {
            this.setState({support: 'mobile'}, (state) => {
                if (this.state.support !== this.state.previousSupport) {

                    TweenMax.set(this.props.proxy.querySelector('.container-category'), {display: 'none'})

                    this.removeEventMouseOver();
                    // Mobile + Tablet > click link redirect to subhome
                    //this.initClick();
                }
                this.setState({previousSupport: this.state.support})
            })
        }

    }

    initMouseOver() {
        let links = this.props.proxy.querySelectorAll(".category")
        let pannels = this.props.proxy.querySelectorAll(".container-pannel")

        this.state.handlerEventFunctionOver = this.overLink.bind(this)

        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener("mouseover", this.state.handlerEventFunctionOver, false)
        }

        this.setState({links: links, pannels: pannels})
    }

    removeEventMouseOver() {
        let links = this.props.proxy.querySelectorAll(".category")
        let pannels = this.props.proxy.querySelectorAll(".container-pannel")

        for (var i = 0; i < links.length; i++) {
            links[i].removeEventListener("mouseover", this.state.handlerEventFunctionOver)
        }
    }

    initClick() {
        let links = this.props.proxy.querySelectorAll(".category")
        let pannels = this.props.proxy.querySelectorAll(".container-pannel")

        this.state.handlerEventFunctionClick = this.clickLink.bind(this)

        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener("click", this.state.handlerEventFunctionClick, false)
        }

        this.setState({links: links, pannels: pannels})
    }

    removeEventClick() {
        let links = this.props.proxy.querySelectorAll(".category")
        let pannels = this.props.proxy.querySelectorAll(".container-pannel")

        for (var i = 0; i < links.length; i++) {
            links[i].removeEventListener("click", this.state.handlerEventFunctionClick)
        }
    }

    clickLink(e) {
        let key = e.currentTarget.dataset.key
        let pannel = this.pannelWithKey(key)
        this.setCurrentPannel(pannel)
        if (this.state.support === 'mobile' && e) {
            e.preventDefault();
            this.closeSearchMenu();
        }
    }

    clickHamburger(evt) {
        if (this.state.openNav) {
            this.closeNav();
        } else {
            this.openNav();
        }
    }

    closeNav() {
        this.state.openNav = false;
        let icon = this.props.proxy.querySelector(".hamburger i")
        icon.classList.add('icon-nav')
        icon.classList.remove('icon-close')
        document.body.classList.remove('menu-open');
        if (this.state.support === 'mobile')
            TweenMax.set(this.props.proxy.querySelector('.container-category'), {display: 'none'})
        this.pannelOut()
    }

    openNav() {
        this.state.openNav = true;
        let icon = this.props.proxy.querySelector(".hamburger i")
        icon.classList.add('icon-close')
        icon.classList.remove('icon-nav')
        document.body.classList.add('menu-open');
        if (this.state.support === 'mobile')
            TweenMax.set(this.props.proxy.querySelector('.container-category'), {display: 'inline-block'})
        this.closeSearchMenu();
    }

    pannelWithKey(key) {
        for (var i = 0; i < this.state.pannels.length; i++) {
            if (this.state.pannels[i].dataset.key == key) {
                return this.state.pannels[i]
            }
        }
    }

    linkWithKey(key) {
        for (var i = 0; i < this.state.links.length; i++) {
            if (this.state.links[i].dataset.key == key) {
                return this.state.links[i]
            }
        }
    }

    setCurrentPannel(pannel) {
        if (!pannel)
            return;

        this.checkOverlay()
        this.hideCurrentPannel()

        let link = this.linkWithKey(pannel.dataset.key)
        link.classList.add('active');
        TweenMax.set(pannel, {autoAlpha: 1, display: "block"})
        this.state.currentPannel = pannel;

        let windowWidth = window.innerWidth;

        if (windowWidth >= 1024) {
            pannel.addEventListener("mouseleave", this.pannelOut.bind(this))
        }
        else {
            pannel.querySelector('.back').addEventListener("click", this.pannelOut.bind(this))
        }
    }

    checkOverlay() {
        if (!this.state.currentPannel) {
            this.props.proxy.querySelector('.hover-div-container').classList.add('opacity')
        }
    }

    pannelOut(e) {
        this.hideCurrentPannel()
        this.state.currentPannel = null
        this.props.proxy.querySelector('.hover-div-container').className = this.props.proxy.querySelector('.hover-div-container').className.replace("opacity", "");
    }

    hideCurrentPannel() {
        if (this.state.currentPannel) {
            let link = this.linkWithKey(this.state.currentPannel.dataset.key)
            link.classList.remove('active');

            this.state.currentPannel.removeEventListener("mouseleave", this.pannelOut.bind(this))
            this.state.currentPannel.querySelector('.back').removeEventListener("click", this.pannelOut.bind(this))
            TweenMax.set(this.state.currentPannel, {autoAlpha: 0})
        }
    }

    overLink(e) {
        if (this.state.searchMenuOpen)
            return;
        let key = e.currentTarget.dataset.key
        let pannel = this.pannelWithKey(key)
        this.setCurrentPannel(pannel)
    }

    render() {
        return <div></div>
    }

}

export default HeaderMenu



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/header/HeaderMenu.js